import { useState } from 'react'
import { Button as AntdButton } from 'antd'
import ShareChangeWithGroup from 'src/screens/menu-builder/components/ShareChangeWithGroup'

/** Opens the same group confirmation used after a recipe or shopping-list save. */
const ShareWithGroupButton = ({
  offer,
  label = 'Share with group…',
  type = 'link',
  component,
  'data-chrome': dataChrome,
  'data-testid': dataTestId,
}) => {
  const ButtonComponent = component || AntdButton
  const [open, setOpen] = useState(false)
  if (!offer?.venueId) return null
  return (
    <>
      <ButtonComponent
        type={type}
        data-chrome={dataChrome}
        data-testid={dataTestId}
        onClick={event => {
          event.stopPropagation()
          setOpen(true)
        }}
      >
        {label}
      </ButtonComponent>
      {open ? (
        <ShareChangeWithGroup offer={offer} onClose={() => setOpen(false)} />
      ) : null}
    </>
  )
}

export default ShareWithGroupButton
